import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tableAnatomy.keys);

const baseStyle = definePartsStyle({
  table: {
    borderCollapse: 'separate',
    borderSpacing: 0,
  },
  th: {
    textTransform: 'uppercase',
    letterSpacing: 'wide',
    fontWeight: 'semibold',
    fontSize: 'xs',
    color: 'blueGrey.600',
    bg: 'blueGrey.50',
    borderBottom: '2px solid',
    borderColor: 'blueGrey.100',
    whiteSpace: 'wrap',
    textAlign: 'center',
  },
  td: {
    fontSize: 'sm',
    borderBottom: '1px solid',
    borderColor: 'blueGrey.100',
    whiteSpace: 'wrap',
    textAlign: 'center',
  },
});

const admin = definePartsStyle({
  table: {
    borderRadius: 'lg',
    overflow: 'hidden',
    boxShadow: 'sm',
    bg: 'white',
    _dark: { bg: 'blueGrey.800' },
  },
  th: {
    color: 'blueGrey.700',
    bg: 'blueGrey.100',
    _dark: { bg: 'blueGrey.700', color: 'blueGrey.100' },
  },
  td: {
    padding: '12px 24px',
    color: 'blueGrey.700',
    _dark: { color: 'blueGrey.200' },
  },
  tr: {
    _hover: {
      bg: 'blueGrey.50',
      _dark: { bg: 'blueGrey.700' },
    },
  },
});

export const tableTheme = defineMultiStyleConfig({
  baseStyle,
  variants: { admin },
  defaultProps: {
    variant: 'admin',
  },
});
